import React, { Fragment} from 'react'



const perPage=20;

let currentPage=1;

let pageArray=[];
let itemList=[];

let totalPagesCal;
let iterator;
const Form = (props) => {
  const{searchText, saveSearchText,  saveResult, saveTotalPages} = props
 



printPaginator()
function *createPagination(total){
    for(let i=1; i<=total; i++){
        yield i;
    }
}
function calcPages(total){
    return parseInt(Math.ceil(total/perPage));
}

function searchImage(e){
    
    currentPage=parseInt(e.target.textContent);
    getImages(e)

}



  const getImages = async (e) =>{
    e.preventDefault();
    
    if(e.target.id==='formulario'){
        currentPage=1
    };
   

  if(pageArray.length>0){
    pageArray=[]
}
    const yourApiKey=process.env.REACT_APP_API_KEY;
    
    const url=`https://pixabay.com/api/?key=${yourApiKey}&q=${searchText}&per_page=${perPage}&page=${currentPage}`;
   
   
    try {
        const response = await fetch(url);
        const resultImage= await response.json();
        saveTotalPages(resultImage.totalHits)
        saveResult(resultImage)
        showImages(resultImage.hits)
        totalPagesCal= calcPages(resultImage.totalHits);
        
    } catch (error) {
        console.log(error);
    }    

  }


  function showImages (images) {
    if(itemList.length>0){
      itemList=[];
      
      }
      console.log(images)
    images.forEach((image,index)=>{
        const {previewURL,likes,views,largeImageURL,id} = image;
     
        itemList.push(
            <div className="w-1/2 md:w-1/3 lg:w-1/4 p-3 mb-4" key={id} >
                <div className="bg-white" >
                    <img className = "w-full" src={previewURL}/>
                    <div className="p-4" >
                        <p className="font-bold" >{likes} <span className="font-light">Me Gusta</span></p>
                        <p className="font-bold" >{views} <span className="font-light">Veces vista</span></p>
                        <a 
                        className=" block w-full bg-blue-800 hover:bg-blue-500 text-white uppercase font-bold text-center rounded mt-5 p-1"
                        href={largeImageURL} target="_blank" rel="noopener noreferrer">Ver imagen</a>
                    </div>
                </div>
            </div>)
        
      
    })
    
  
  }


  function printPaginator(){
    if(pageArray.length>0){
      pageArray=[]
    }
    iterator = createPagination(totalPagesCal);
    while(true){
        const {value, done} = iterator.next();
        if(done) return;
        
        pageArray.push(
            <a href="#" key={value} data-pagina={value} className="siguiente bg-yellow-400 px-4 py-1 
            mr-2 font-bold  mb-4 uppercase rounded" onClick={searchImage} value={value}>
                {value}
            </a>

        )
      

    }
}



  return (
  <Fragment>
  
    <h1 className="text-center text-3xl text-white my-10 font-bold uppercase">Buscador de Imágenes Pixabay</h1>

    <div className="buscador max-w-lg mx-auto ">
        <form id="formulario" className="" onSubmit={getImages}>
            <div>
                <label 
                    className="block text-white font-bold uppercase"
                >Término Búsqueda</label>
                <input 
                    type="text"
                    className="mt-3 rounded w-full p-2 "
                    placeholder="Término de búsqueda. Ejemplo: Café o Futbol"
                    id="termino"
                    onChange={e=>saveSearchText(e.target.value)}
                />

                <input 
                    type="submit"
                    value="Buscar Imágenes"
                    className="mt-5 w-full py-2 bg-yellow-400 cursor-pointer font-bold uppercase hover:bg-yellow-500 rounded"
                />   
            </div>
        </form>
    </div>
    <div id="resultado" className="container mx-auto mt-10  flex flex-wrap">
        {itemList}
      </div>
      <div id="paginacion" className="container mx-auto mb-10 text-center flex flex-wrap justify-center">
       {pageArray}
         
        
      </div> 
   
   
    </Fragment>

  );
}

export default Form